const DEFAULT_META_KEYS = ['message', 'httpStatus', 'requestId', 'source', 'status', 'zonedDateTime'];

export type GetFirstValidationErrorOptions = {
  metaKeys?: string[];
};

export function getFirstValidationError(
  error: unknown,
  options: GetFirstValidationErrorOptions = {}
): string | null {
  const data = error && typeof error === 'object' && 'data' in error
    ? (error as { data?: Record<string, unknown> }).data
    : (error as Record<string, unknown> | null | undefined);
  if (!data || typeof data !== 'object') return null;
  const metaKeys = options.metaKeys ?? DEFAULT_META_KEYS;
  const errorsObj =
    typeof data.errors === 'object' && data.errors !== null
      ? (data.errors as Record<string, unknown>)
      : data;
  const firstFieldKey = Object.keys(errorsObj).find(
    (k) => !metaKeys.includes(k) && typeof errorsObj[k] === 'string'
  );
  if (firstFieldKey) return errorsObj[firstFieldKey] as string;
  if (typeof data.message === 'string') return data.message;
  return null;
}
